/**
 * PageInfo Module
 * Contains basic information about the page (that is updated permanently)
 *
 * @module PageInfo
 * @author EN GARDE
 * @version 1.1
 *
 * Change Log:
 * 2.0  refactored to use native js instead of jquery
 * 1.1	added update on resize, switched to lodash throttle/debounce
 * 1.0	initial version
 */

import throttle from 'lodash/throttle';
import debounce from 'lodash/debounce';

class PageInfo {

	data = {};

	constructor() {

		window.addEventListener( 'scroll', throttle( () => this.update(), 300 ) );

		window.addEventListener( 'resize', debounce( () => this.update( true ), 300, {
			trailing: true,
			leading: false,
			maxWait: 1500
		} ) );

		this.update();
	}

	init() {
		return this.update( true );
	}

	update( force = false ) {

		const oldData = this.data;
		const newData = {};

		newData.vpTop = window.scrollY;

		// did scrolling even change?
		if ( ! force && ( oldData && oldData.vpTop === newData.vpTop ) ) {
			return false;
		}

		newData.vpWidth = document.documentElement.clientWidth;
		newData.vpHeight = document.documentElement.clientHeight;
		newData.docWidth = document.documentElement.scrollWidth;
		newData.docHeight = document.documentElement.scrollHeight;
		newData.vpBottom = newData.vpTop + newData.vpHeight;

		this.data = newData;
		return true;
	}

	/**
   * Get current data
   * @return {object} data
   */
	get() {
		return this.data;
	}

	/**
   * Check if two datasets match
   * @param  {object} data1 – first data set to compare
   * @param  {object} data2 – second data set to compare
   * @return {boolean} – does match
   */
	match( data1, data2 = undefined ) {

		if ( 'undefined' === typeof data2 ) {
			data2 = this.get();
		}

		if ( data1 &&
      data2 &&
      data1.vpHeight === data2.vpHeight &&
      data1.vpWidth === data2.vpWidth &&
      data1.docHeight === data2.docHeight &&
      data1.docWidth === data2.docWidth
		) {
			return true;
		}
		return false;
	}
}

const PageInfoInstance = new PageInfo();
export default PageInfoInstance;
